module.exports = __webpack_public_path__ + "static/media/OP_Portal_Arrow_White_LT.32427dc3.svg";